import { MapTo } from '@adobe/aem-react-editable-components';
import { WithEmptyPlaceholder } from '../../../../lib/hoc/WithEmptyPlaceholder';
import TeamMemberTrainings from './TeamMemberTrainings';
import { isNil } from '../../../../lib/utils/isNil';
import WithPage from '../../../../lib/hoc/WithPage/WithPage';
import { TeamMemberTrainingsProps } from './TeamMemberTrainings.types';
import WithAuth from '../../../../lib/hoc/WithAuth/WithAuth';
import { PageType } from '../../../../lib/hooks/usePageDetails';

const RESOURCE_TYPE = 'learning-academy/components/custom/teammembercourses';

const EditConfig = {
  emptyLabel: 'Team Member Courses',
  isEmpty: (props: TeamMemberTrainingsProps) => !props || Object.values(props).some(prop => isNil(prop)),
};

export default MapTo<TeamMemberTrainingsProps>(RESOURCE_TYPE)(
  ...WithEmptyPlaceholder(WithPage(WithAuth(TeamMemberTrainings), [PageType.TeamMemberDetails]), EditConfig),
);
